import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Services.css';

function Services() {
  const [services, setServices] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [servicesRes, categoriesRes] = await Promise.all([
        axios.get('/api/services'),
        axios.get('/api/categories')
      ]);
      
      setServices(servicesRes.data);
      setCategories(categoriesRes.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching services:', error);
      setLoading(false);
    }
  };

  const filteredServices = selectedCategory === 'all' 
    ? services 
    : services.filter(s => s.categoryId === selectedCategory);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Φόρτωση...</p>
      </div>
    );
  }

  return (
    <div className="services-page">
      <div className="services-hero">
        <div className="container">
          <h1 className="page-title">Οι Υπηρεσίες μας</h1>
          <p className="page-subtitle">
            Επαγγελματικές λύσεις για κάθε ανάγκη της επιχείρησής σας
          </p>
        </div>
      </div>

      <div className="container">
        <div className="category-filter">
          <button 
            className={`filter-btn ${selectedCategory === 'all' ? 'active' : ''}`}
            onClick={() => setSelectedCategory('all')}
          >
            Όλες οι Υπηρεσίες
          </button>
          {categories.map(cat => (
            <button 
              key={cat.id}
              className={`filter-btn ${selectedCategory === cat.id ? 'active' : ''}`}
              onClick={() => setSelectedCategory(cat.id)}
            >
              {cat.icon} {cat.name}
            </button>
          ))}
        </div>

        <div className="services-grid">
          {filteredServices.length === 0 ? (
            <div className="no-services">
              <p>Δεν βρέθηκαν υπηρεσίες σε αυτή την κατηγορία.</p>
            </div>
          ) : (
            filteredServices.map(service => (
              <div key={service.id} className="service-card">
                {service.isFeatured && (
                  <div className="featured-badge">⭐ Προτεινόμενο</div>
                )}
                
                <div className="service-header">
                  <div className="service-category">
                    {service.category?.icon} {service.category?.name}
                  </div>
                  {service.price && (
                    <div className="service-price">{service.price}</div>
                  )}
                </div>

                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>

                {service.features && service.features.length > 0 && (
                  <div className="service-features">
                    <h4>Περιλαμβάνει:</h4>
                    <ul>
                      {service.features.map((feature, index) => (
                        <li key={index}>
                          <span className="feature-icon">✓</span>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <button className="btn-service-cta">
                  Μάθετε Περισσότερα
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default Services;
